// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "selectedFare-2aDz_";
var _4 = "compareFares-1lTyF";
var _5 = "groupTitle-3F7P4";
var _6 = "tableRow-2kD-m";
var _7 = "fareHeadingItem-24k26";
var _8 = "fareHeadingItem_isKey-HtPNi";
var _9 = "fareHeadingItem_isFirstClass-VOKWY";
var _a = "fareHeadingItem__title-17DBf";
var _b = "slider_withoutImages-X9350";
var _c = "col-2r7SX";
var _d = "cellContent__full-1FCn-";
export { _1 as "__esModule", _2 as "mobile", _3 as "selectedFare", _4 as "compareFares", _5 as "groupTitle", _6 as "tableRow", _7 as "fareHeadingItem", _8 as "fareHeadingItem_isKey", _9 as "fareHeadingItem_isFirstClass", _a as "fareHeadingItem__title", _b as "slider_withoutImages", _c as "col", _d as "cellContent__full" }
export default { "__esModule": _1, "mobile": _2, "selectedFare": _3, "compareFares": _4, "groupTitle": _5, "tableRow": _6, "fareHeadingItem": _7, "fareHeadingItem_isKey": _8, "fareHeadingItem_isFirstClass": _9, "fareHeadingItem__title": _a, "slider_withoutImages": _b, "col": _c, "cellContent__full": _d }
